import React from "react";
import "./VideoFooter.css";
import MusicNoteIcon from "@material-ui/icons/MusicNote";
import Ticker from "react-ticker";
function VideoFooter({ channel, desc, song }) {
  return (
    <div className="videoFooter">
      <div className="videoFooter__text">
        <h3>@{channel}</h3>
        <p>{desc}</p>
        <div className="videoFooter__ticker">
          <MusicNoteIcon className="videoFooter__Icon" />
          <Ticker mode="smooth">
            {({ index }) => (
              <>
                <p>{song}</p>
              </>
            )}
          </Ticker>
        </div>
      </div>
      <img
        className="videoFooter__record"
        src="https://i7.pngguru.com/preview/386/378/435/phonograph-record-disc-jockey-mediahut-clip-art-music-disk-cliparts.jpg"
        alt="images"
      />
    </div>
  );
}

export default VideoFooter;
